<script lang="ts">
    import { Turnstile } from 'svelte-turnstile';
</script>

<Turnstile on:turnstile-expired={() => console.log('turnstile-expired')} siteKey="0x4AAAAAAAInMtyAA1wEPPiC" theme="light" />
